jQuery(document).ready(function($) {
	var $singleProductAdmission = $('.page-general-admission');
	if ($singleProductAdmission.length > 0) {
		// reorder date/time picker
		var $bookingForm = $singleProductAdmission.find('form #wc-bookings-booking-form');
		var $datePicker = $singleProductAdmission.find('fieldset.wc-bookings-date-picker');
		var $slotPicker = $datePicker.next();
		$slotPicker.prependTo($bookingForm);
		$datePicker.prependTo($bookingForm);
		// scroll to time picker on date picker click
		$datePicker.on("date-selected", function(event, fdate) {
			$slotPicker.find('ul').empty().append('<li>Loading available time slots...</li>');
			navHandler.activateItemIntoView($slotPicker);
		});
		$slotPicker.find('input#wc_bookings_field_start_date').on("change", function() {
			var inputValue = $(this).val();
			if (typeof inputValue !== 'undefined' && inputValue) {
				setTimeout(function() {
					navHandler.activateItemIntoView($bookingForm.find('.form-field-person'));
				},10);
			}
		});
		$bookingForm.on("change",'input, select:not("#wc-bookings-form-start-time, #wc-bookings-form-end-time")', function() {
			$bookingForm.find(".wc-bookings-booking-cost").html("Calculating total tickets...<strong>&nbsp;</strong>");
		});
	}
})
